import React from 'react';
import { components, } from 'react-select';

const MenuList = props => {
  return (
    <components.MenuList {...props}>
      {Array.isArray(props.children) ? props.children.slice(0, 300) : props.children}
    </components.MenuList>
  );
};

export default MenuList;
